<template>
    <div class="slm-history-map__view-toggle" v-if="histories.length">
        <label class="slm-history-map__view-toggle--option list" :class="listView === 'list' ? 'selected' : ''">
            <input class="show-for-sr" type="radio" value="list" v-model="listView">
            Lista
        </label>
        <label class="slm-history-map__view-toggle--option grid" :class="listView === 'grid' ? 'selected' : ''">
            <input class="show-for-sr" type="radio" value="grid" v-model="listView">
            Rutnät
        </label>
    </div>
</template>

<script>
export default {
    name: 'view-toggle-component',
    computed: {
        listView: {
            get() {
                return this.$store.state.listView
            },
            set(val) {
                this.$store.commit('setListView', val)
                this.$store.dispatch('setUrl');
            }
        },
        histories() {
            return this.$store.state.filteredHistories;
        }
    }
}
</script>